import classNames from 'classnames/bind'

import styles from './LogValue.module.scss'
import LogValueInner from './LogValueInner'

import type {LogValueNode} from '../../type'
import type {FC} from 'react'

const cx = classNames.bind(styles)

interface LogValueListProps {
    nodes: LogValueNode[]
}

const LogValueList: FC<LogValueListProps> = ({nodes}) => (
    <span className={cx('list')}>
        {nodes.map((node, idx) => (
            // index key는 노드 배열이 불변이므로 무관
            <span key={idx} className={cx('listItem')}>
                <LogValueInner node={node} depth={0} />
            </span>
        ))}
    </span>
)

export default LogValueList
